/**
 * @generated SignedSource<<e976eddccbdc837eec8388734139052e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hasMoreDataWarning_waitingRoomAppointments$data = {
  readonly hasMoreData: boolean;
  readonly " $fragmentType": "hasMoreDataWarning_waitingRoomAppointments";
};
export type hasMoreDataWarning_waitingRoomAppointments$key = {
  readonly " $data"?: hasMoreDataWarning_waitingRoomAppointments$data;
  readonly " $fragmentSpreads": FragmentRefs<"hasMoreDataWarning_waitingRoomAppointments">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "hasMoreDataWarning_waitingRoomAppointments",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasMoreData",
      "storageKey": null
    }
  ],
  "type": "WaitingRoomAppointmentsOutput",
  "abstractKey": null
};

(node as any).hash = "09603dc2d9c47cf2d9ad43b86138632d";

export default node;
